"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _AuthStore = require("../store/AuthStore");

var PortalStore = (0, _AuthStore.defineAuthStore)({
  initialState: [],
  name: 'PortalStore',
  onAuthLoad: function onAuthLoad(auth) {
    return auth.portal;
  }
}).register(_dispatcher.default);
var _default = PortalStore;
exports.default = _default;
module.exports = exports.default;